import isObject from "./isObject";
import { AnyObject } from "/types/objectType";

export const areSameObjects = (a: AnyObject, b: AnyObject) =>
    isObject(a) && isObject(b) && JSON.stringify(a) === JSON.stringify(b);

export const areSameArrays = (a: any[], b: any[]) =>
    Array.isArray(a) &&
    Array.isArray(b) &&
    JSON.stringify(a) === JSON.stringify(b);